import { render } from "./NotSubmittedCard.vue?vue&type=template&id=18e524c8&scoped=true"
import script from "./NotSubmittedCard.vue?vue&type=script&lang=js"
export * from "./NotSubmittedCard.vue?vue&type=script&lang=js"

import "./NotSubmittedCard.vue?vue&type=style&index=0&id=18e524c8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\s574086\\textbook-ui\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18e524c8"]])

export default __exports__